export default __webpack_public_path__ + "static/media/broken.f5f7ee6b.svg";